// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { languages } from "./envs-utils";

const domainBE = 'lumsa-drupal-dev.mashfrog.com';
const domainUrlApi = `https://${domainBE}`;

export const environment = {
  languages: languages,
  production: false,
  client_id: 'a0cf7789-1153-4488-ada6-1f9c60ecf0f6',
  client_secret: '5lyox4cj9q4djxb',
  client_id_secret_preview: '916b58a3-fb19-4e5f-9317-ef2a25417542',
  username_no_auth: 'visitor',
  password_no_auth: 'visitor',
  urlApi: domainUrlApi,
  ulrApiPreview: domainBE,
  urlApiToProxy: null,
  urlFE: `https://lumsa-dev.mashfrog.com`,
  useProxy: false,
  headers: null,
  access_token: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjBiOTQ4MGE2ZWRhYTE2YTU3OWQ4MGMzMDZjYTBkNmU3NjEwZmYzYTViMmE0ZjgzMjNlMmQzN2Y1YmMwNzgzMThiY2RmOTk4MjE0ODBmNjgzIn0.eyJhdWQiOiJhMGNmNzc4OS0xMTUzLTQ0ODgtYWRhNi0xZjljNjBlY2YwZjYiLCJqdGkiOiIwYjk0ODBhNmVkYWExNmE1NzlkODBjMzA2Y2EwZDZlNzYxMGZmM2E1YjJhNGY4MzIzZTJkMzdmNWJjMDc4MzE4YmNkZjk5ODIxNDgwZjY4MyIsImlhdCI6MTczNjI1NzIxNSwibmJmIjoxNzM2MjU3MjE1LCJleHAiOjIwNTE4MzMyMTUuMzY4MjkyLCJzdWIiOiIzIiwic2NvcGUiOlsiYXV0aGVudGljYXRlZCIsInZpc2l0b3IiXX0.IPDyaadBgtpPWjcqmZxYKLiM4pfIyJLiAJ9r83wP63YMsTepTPjm7i9v2bSfA4vZUZXbeKZtpO4Ku2c5htYbxi19Z5e8wqo8Ev2mmVXaLk0tZ_cqZxixLZuZfzEkSTi76NWUB4prxDUH0eL5_mxwbnUyVO8tSQMMgWaadu8_Yyy1IbSOm8xkx8H4E4WE245SIEpiW7Qn62JIJcsTcaTYksdLvhjYyAhlsVRVAJFxRaqc_kKBYLh7eSjQ195LG6gT6uF_ANLil8KKbjD_VDMPsiikUQIsGk-2hXdzzV_Xg7FSysec30jjRX6u_j99BWARgYnhe5R8r_OqTjRd80JMplNslPycOIYtb1PNdHSDkn1jVCPUkRF5AFD8-vh_6xE3gj0g9F5SumLOzcrAbMSx1XH8KaKwlPxF6Qa9czm8YkmEVs7gl--R-6F8lW_F9FWnX6pda7tOOmMQ7keLTOkeSq3pMIZLeaAaB_PdwEMYibIIdqfAGQDkKiv0qEWXhT8gb0FM7HRDllTSvwLk-vq8QLzVH3Ahl13lrOmw_1bBtEVQC7v1YNZXKGxlmQpg5o75xmKVczdjYtProYtZYUSGs7xVrKjHJ9szuG2RvpnjCu5ZGqHtVJV10di_2REV7ZcFOtstkSwXhpW491fA4Y5FrDxPXUS-yaRQ_OEflA6Oq64",
  lumiaScriptPath:"https://d3so8u9uewocbp.cloudfront.net/bundle/lumia-loader-test.js",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

